module.exports = "button {\n  background-color: #e85356;\n  color: #FFFFFF;\n}\n\nbutton:hover {\n  background-color: #ffffff;\n  color: black;\n}"